import { LegalPage } from './LegalPage';

/** Copy lives in content/fallbacks.ts (legal.terms / legal.termsMeta) and is
 *  editable from admin → Marketing content → Legal. */
export function Terms() {
  return <LegalPage kind="terms" />;
}
